export const PARTNERSHIP_HOVER_CARD_DATA_KR = [
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg1.png',
    title: '실시간 모니터링',
    desc: '운전자의 정보, 충전 요금, 이용 전력량, 충전소 상태를 실시간으로 제공합니다',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg2.png',
    title: '서비스 제공',
    desc: 'SaaS 웹서비스 형태로 안정적이고 우수한 보안을 제공합니다',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg3.png',
    title: '완벽한 제어',
    desc: '충전 시작 및 종료뿐만 아니라 예약 기능을 통한 점유도 가능합니다',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg4.png',
    title: 'Smart 충전',
    desc: '전력요금이 비쌀 때 충전 속도를 조절하거나 요금을 관리할 수 있습니다',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg5.png',
    title: '무제한 업데이트',
    desc: '새로운 버전 출시 시 최신버전으로 업데이트 되어 보안 위협을 완화하고 데이터의 기밀성과 무결성을 보장합니다',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg6.png',
    title: '한국전력 연동',
    desc: 'WEV 운영 플랫폼은 한국전력 서비스 마켓에 등록되어 있어, 실시간 전력 요금과 청구서를 한 곳에서 확인할 수 있습니다',
  },
]

export const PARTNERSHIP_HOVER_CARD_DATA_EN = [
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg1.png',
    title: 'Real-time Monitoring',
    desc: 'Provides real-time information on driver details, charging fees, energy usage, and charging station status.',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg2.png',
    title: 'Service Provision',
    desc: 'Offers a SaaS web service with reliable and excellent security.',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg3.png',
    title: 'Complete Control',
    desc: 'Allows not only charging start and end but also reservation features for occupancy management.',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg4.png',
    title: 'Smart Charging',
    desc: 'Adjusts charging speed or manages fees when electricity rates are high.',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg5.png',
    title: 'Unlimited Updates',
    desc: 'WEV mitigates security threats and ensures data confidentiality and integrity.',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg6.png',
    title: 'Korean Power Integration',
    desc: 'WEV operating platform provides real-time power rates and bills in one place.',
  },
]
export const PARTNERSHIP_HOVER_CARD_DATA_JP = [
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg1.png',
    title: 'リアルタイムモニタリング',
    desc: '運転者の情報、充電料金、使用電力量、充電ステーションの状態をリアルタイムで提供します。',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg2.png',
    title: 'サービス提供',
    desc: 'SaaSウェブサービス形式で安定した優れたセキュリティを提供します。',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg3.png',
    title: '完全な制御',
    desc: '充電の開始と終了だけでなく、予約機能を通じて占有管理も可能です。',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg4.png',
    title: 'スマート充電',
    desc: '電力料金が高いときに充電速度を調整したり、料金を管理したりできます。',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg5.png',
    title: '無制限のアップデート',
    desc: '新しいバージョンがリリースされると最新バージョンに更新され、セキュリティリスクを軽減し、データの機密性と整合性を保証します。',
  },
  {
    img_url: '/images/wev/partnership/wev_partnership_section01_bg6.png',
    title: '韓国電力統合',
    desc: 'WEV運営プラットフォームは韓国電力サービス市場に登録されており、リアルタイムの電力料金と請求書を一箇所で確認できます。',
  },
]

export const PARTNERSHIP_ITEM_SECTION_04_KR = [
  {
    text: '주차장',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_1.png',
  },
  {
    text: '정부기관',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_2.png',
  },
  {
    text: '아파트/빌라',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_3.png',
  },
  {
    text: '자동차 대리점',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_4.png',
  },
  {
    text: '음식점',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_5.png',
  },
  {
    text: '주유소',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_6.png',
  },
  {
    text: '병원',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_7.png',
  },
  {
    text: '숙박업소',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_8.png',
  },
  {
    text: '쇼핑몰',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_9.png',
  },
  {
    text: '기업',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_10.png',
  },
]
export const PARTNERSHIP_ITEM_SECTION_04_EN = [
  {
    text: 'Parking Lots',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_1.png',
  },
  {
    text: 'Agency',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_2.png',
  },
  {
    text: 'Apartments/Villas',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_3.png',
  },
  {
    text: 'Car Dealerships',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_4.png',
  },
  {
    text: 'Restaurants',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_5.png',
  },
  {
    text: 'Gas Stations',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_6.png',
  },
  {
    text: 'Hospitals',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_7.png',
  },
  {
    text: 'Accommodation',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_8.png',
  },
  {
    text: 'Shopping Malls',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_9.png',
  },
  {
    text: 'Corporations',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_10.png',
  },
]
export const PARTNERSHIP_ITEM_SECTION_04_JP = [
  {
    text: '駐車場',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_1.png',
  },
  {
    text: '政府機関',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_2.png',
  },
  {
    text: 'アパート/ヴィラ',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_3.png',
  },
  {
    text: '自動車代理店',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_4.png',
  },
  {
    text: 'レストラン',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_5.png',
  },
  {
    text: '給油所',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_6.png',
  },
  {
    text: '病院',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_7.png',
  },
  {
    text: '宿泊施設',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_8.png',
  },
  {
    text: 'モール',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_9.png',
  },
  {
    text: '企業',
    img_url: '/images/wev/partnership/wev_partnership_section04_item_10.png',
  },
]

export const PARTNERSHIP_CONSULT_OPTION_KR = [
  { id: 0, value: 'PRODUCT_PURCHASE', text: '제품 구매' },
  { id: 1, value: 'CPO_SOLUTION', text: 'CPO 솔루션' },
  { id: 2, value: 'PARTNER_AFFILIATION', text: '파트너 제휴' },
  { id: 3, value: 'OTHERS', text: '기타' },
]

export const PARTNERSHIP_CONSULT_OPTION_EN = [
  { id: 0, value: 'PRODUCT_PURCHASE', text: 'Product Purchase' },
  { id: 1, value: 'CPO_SOLUTION', text: 'CPO Solution' },
  { id: 2, value: 'PARTNER_AFFILIATION', text: 'Partner Affiliation' },
  { id: 3, value: 'OTHERS', text: 'Others' },
]

export const PARTNERSHIP_CONSULT_OPTION_JP = [
  { id: 0, value: 'PRODUCT_PURCHASE', text: '製品購入' },
  { id: 1, value: 'CPO_SOLUTION', text: 'CPOソリューション' },
  { id: 2, value: 'PARTNER_AFFILIATION', text: 'パートナー提携' },
  { id: 3, value: 'OTHERS', text: 'その他' },
]
